/* R32 five right-edge tabs. Navigation only; existing apps/services keep ownership of behavior. */
(() => {
  'use strict';
  if (window.__mmR32CollectorDock) return;
  window.__mmR32CollectorDock = true;
  function init(){
    const dock=document.getElementById('MMR32CollectorDock');
    if(!dock) return;
    document.body.classList.add('mm-r32-dock-ready');
    const mike=dock.querySelector('[data-mm-mike-tab]');
    const mikeSlot=dock.querySelector('[data-mm-tools-mike]');
    if(mike&&mikeSlot){
      const reflect=()=>{mikeSlot.hidden=mike.hidden;};
      reflect();
      new MutationObserver(reflect).observe(mike,{attributes:true,attributeFilter:['hidden']});
    }
    dock.querySelectorAll('[data-mm-tool]').forEach(tab=>{
      if(tab.dataset.mmEdgeReady) return;
      tab.dataset.mmEdgeReady='true';
      tab.addEventListener('click',()=>{
        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push({event:'mm_right_edge_tab_click',tool:tab.dataset.mmTool||'',page_path:location.pathname});
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();